<template>
  <div class="quick-entrance">
    <template v-for="item in allLinksList" >
      <div
        v-if="item.isShow || item.key=='employee'"
        :key="item.key"
        class="entrance-item c_pointer sk--hover-item"
        :class="{'c_pointer':item.link, 'span_4':lang=='en'}"
        @click="handleClickToLink(item)"
      >
        <!-- iconType: 2 表示icon和label整体按图片返回  -->
        <div class="icon-wrapper" :key="item.key" v-if="item.iconType === 2">
          <el-badge :value="item.unReadMessage" :hidden="!item.unReadMessage">
            <img class="img-size" :src="item.image" alt="">
          </el-badge>
        </div>
        <template v-else>
          <div class="icon-wrapper">
            <span class="entry-bg sk-light9-bg">
              <xin-icon v-if="item.icon" :xin-type="item.icon" class="f_s18 sk-text" />
              <img v-else-if="item.image" :src="item.image" width="16px"/>
            </span>
          </div>
          <span class="entry-text sk-color">{{item.label}}</span>
        </template>

      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  import { HomeApi } from '../../service/home-api.service';
  import { entrance } from './const'
import { XrxsCommonUtils } from '@xin/xin-core';

  const moduleInfra = namespace('moduleInfra');

  @Component({})
  export default class QuickEntrance extends Vue {

    @moduleInfra.Getter('getHeaderNavItemsEmp') public headerNavItemsEmp!: any;
    @moduleInfra.Getter('getHasEmployeeAccount') public hasEmployeeAccount!: number;

    @Prop({default:()=>[]})
    applyList!:any

    @Prop({default:()=>({})})
    appSetting!:any

    lang = window.XinI18n.getLangCache() || 'zh'

    entrance = entrance

    externalLinksList = []

    shortcuts = []

    // 根据左侧菜单展示
    get entranceList(){
      const obj:any = {}
      console.log('this.headerNavItemsEmp',this.headerNavItemsEmp)
      const navlist = this.headerNavItemsEmp && this.headerNavItemsEmp.children ? this.headerNavItemsEmp.children : []
      const list:any = []
      navlist.forEach((i:any) => {
        if(i.children){
          list.push(...i.children)
        }else{
          list.push(i)
        }
      })
      list.forEach((i:any) => {
        obj[i.key] = i
      })
      console.log(obj);

      return entrance.map((item:any) => {
        if(obj[item.key]){
          item.isShow = true
          item.link = obj[item.key].link
        }else if(!['apply','leave','goOut','workOvertime','employee'].includes(item.key)){
          item.isShow = false
        }
        return item
      })
    }

    get allLinksList(){
      return [...this.entranceList,...this.externalLinksList, ...this.shortcuts]
    }

    @Watch("applyList", { deep: true, immediate:true })
    watchApplyList() {
      for(let i=0; i<this.entrance.length; i++){
        const item:any = this.entrance[i]
        if(typeof item.fn == 'function'){
          const {isShow, link} = item.fn(this.applyList,this.appSetting)
          item.isShow=isShow
          item.link=link?link:item.link
        }
      }
    }

    created(){
      this.getExteralAppLinks()
      // 快捷方式
      this.ajaxGetHomeFunction()
    }

    // 快捷方式
    async ajaxGetHomeFunction() {
      try {
        const { data, status } = await HomeApi.ajaxGetHomeFunction()
        if(status) {
          this.shortcuts = data?.map((item:any) => ({
            ...item,
            isShow: true, // 不显示，接口就会不返回
            key: item.label,
          }))
          .filter((item:any) => item.functionName !== "cinlyn")
        }
      } catch (error) {
        console.log('error: ', error);
      }
    }

    // 外链
    getExteralAppLinks(){
      HomeApi.getAppLinks().then((res:any) => {
        if(res.status){
          const list = res.data || [];
          this.externalLinksList = list.map((item:any)=>({
            key: item.appName,
            label: item.appName,
            image: item.appIcon,
            link: item.loginUri,
            thirdPartyLink: item.thirdPartyLink,
            isShow: true,
            isRead: item.isRead,
          }))
        }
      })
    }

    handleClickToLink(item:any){
      const {link, key} = item;
      this.XrxsTracker.$track('a_homeClickQuickEntrance','',key)
      if(item.thirdPartyLink && item.link){
        Vue.http.get(item.link).then((res:any) => {
          if(res.data && res.data.data){
            window.location.href = res.data.data
          }
        });
      }else{
        if (item.linkType == 2) {
          XrxsCommonUtils.xOpen(item.link)
        } else {
          window.location.href=link
        }
      }
    }

  }
</script>

<style lang="scss" scoped>
.quick-entrance {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  border-radius: 4px;
  background: #fff;
  .img-size {
    width: 36px;
  }
  .entrance-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 20%;
    &.span_4{
      width: 25%;
    }
    .icon-wrapper {
      position: relative;
      display: inline-flex;
      /* 未读消息 badge 样式 */
      ::v-deep .el-badge__content {
        background-color: #F73838;
        border-radius: 10px;
        font-size: 12px;
        line-height: 16px;
        font-family: 'D-DIN', 'DIN-Bold', sans-serif;
        font-weight: 700;
        color: #fff;
      }
    }
    .entry-bg{
      display: flex;
      width: 28px;
      height: 28px;
      justify-content: center;
      align-items: center;
      border-radius: 2px;
    }
    .entry-text{
      margin-top: 2px;
      font-size: 12px;
      font-weight: 400;
      color: var(--xs-text-color-primary);
      text-align: center;
    }
  }
}
</style>
